import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../../hooks/useAuth";
import { COLUMN_DEFINITIONS } from "./table.config";
import {
  fetchManifests,
  manifestUpdated,
  resetManifests,
  selectAllManifests,
} from "../../../../redux/reducers/manifests/manifestsSlice";
import { updateManifest } from "../../../../redux/reducers/manifests/manifestSlice";
import TableLayout from "../../../../layouts/TableLayout";
import CreateModal from "../../../Manifests/CreateModal";

const OrgManifests = ({ organization }) => {
  const { user } = useAuth();
  const params = useParams();
  const dispatch = useDispatch();

  const manifests = useSelector(selectAllManifests);
  const manifestsStatus = useSelector((state) => state.manifests.status);

  const [createModalOpen, setCreateModalOpen] = useState(false);

  useEffect(() => {
    if (!user?._id || !params.id) return;

    dispatch(
      fetchManifests({
        parent: user.parentCompany,
        userId: user._id,
        organizationId: params.id,
      })
    );
  }, [dispatch, user?._id, user?.parentCompany, params.id]);

  useEffect(() => {
    return () => dispatch(resetManifests());
  }, [dispatch]);

  async function handleUpdate(e, setLoading) {
    const update = {
      parentId: user.parentCompany,
      manifestId: e.row.original._id,
      data: e.data,
    };

    const res = await dispatch(updateManifest(update)).unwrap();

    if (res.status === "success") {
      dispatch(manifestUpdated(res.data));

      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }

  return (
    <div className="xl:col-span-6 col-span-8 max-h-[450px]">
      <TableLayout
        mainAction={{ onClick: () => setCreateModalOpen(true) }}
        scrollable
        id="manifests"
        title="Manifests"
        loading={manifestsStatus === "loading"}
        columns={COLUMN_DEFINITIONS}
        data={manifests}
        hideCheckbox
        updateData={handleUpdate}
      />
      <CreateModal
        modalOpen={createModalOpen}
        setModalOpen={setCreateModalOpen}
      />
    </div>
  );
};

export default OrgManifests;
